import { useSelector, useDispatch } from "react-redux";
import {
  updateName,
  updateEmail,
  updateSubject,
  updateMessage,
  resetNewUser,
} from "../../store/newUserSlice";
import "./index.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Contact = () => {
  const dispatch = useDispatch();
  const theme = useSelector((state) => state.theme);
  const newUser = useSelector((state) => state.newUser);
  const { name, email, subject, message } = newUser;
  const textColor = theme === "LIGHT" ? "contact-light" : "contact-dark";
  const contactFormClass =
    theme === "LIGHT" ? "contact-form-light" : "contact-form-dark";
  const contactInput =
    theme === "LIGHT" ? "contact-form-input-light" : "contact-form-input-dark";
  const contactLabel =
    theme === "LIGHT" ? "contact-form-label-light" : "contact-form-label-dark";
  const contactTextArea =
    theme === "LIGHT"
      ? "contact-form-message-light"
      : "contact-form-message-dark";

  const submitRequest = (e) => {
    e.preventDefault();
    if (name !== "" && email !== "" && subject !== "" && message !== "") {
      dispatch(resetNewUser());
    }
  };

  return (
    <div className={`contact ${textColor}`}>
      <h1 className="contact-title">Get in touch</h1>
      <p className="contact-caption">Let's build something awesome.</p>
      <hr
        style={{
          background:
            theme === "LIGHT"
              ? "rgba(0, 0, 0, 0.10)"
              : "rgba(255, 255, 255, 0.10)",
          width: "100vw",
          position: "relative",
          left: "calc((100% - 100vw) / 2)",
        }}
      />
      <form
        className={`contact-form ${contactFormClass}`}
        onSubmit={submitRequest}
      >
        <h3 className="contact-form-title">New Message</h3>
        <label htmlFor="name" className={`contact-form-label ${contactLabel}`}>
          Name:
          <input
            id="name"
            type="text"
            className={`contact-form-input ${contactInput}`}
            placeholder="Enter your name"
            value={name}
            onChange={(e) => {
              dispatch(updateName(e.target.value));
            }}
          />
        </label>
        <label htmlFor="email" className={`contact-form-label ${contactLabel}`}>
          Email:
          <input
            id="email"
            type="email"
            className={`contact-form-input ${contactInput}`}
            value={email}
            placeholder="Enter your email"
            onChange={(e) => {
              dispatch(updateEmail(e.target.value));
            }}
          />
        </label>
        <label
          htmlFor="subject"
          className={`contact-form-label ${contactLabel}`}
        >
          Subject:
          <input
            id="subject"
            type="text"
            className={`contact-form-input ${contactInput}`}
            value={subject}
            placeholder="Enter your subject"
            onChange={(e) => {
              dispatch(updateSubject(e.target.value));
            }}
          />
        </label>
        <textarea
          rows={6}
          className={`contact-form-message ${contactInput} ${contactTextArea}`}
          type="text"
          value={message}
          placeholder="Enter your message here"
          onChange={(e) => {
            dispatch(updateMessage(e.target.value));
          }}
        ></textarea>
        <button
          type="submit"
          className="home-contact-button mt-4 contact-send-button"
        >
          Send
        </button>
      </form>
      <section className="contact-social-icons-container">
        <div>
          <a href="mailto:om.kumbhare29@gmail.com" target="blank">
            <img
              src={
                theme === "LIGHT"
                  ? "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447577/Portfolio%20App/Message_-_Fill_ukthre.png"
                  : "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696484006/Portfolio%20App/Frame_fobmsh.png"
              }
              alt="mail"
            />
          </a>
          <a
            href="https://docs.google.com/document/d/1kMZfeE_iFwegN-AT05JQ_E7bcz377eXeUbU1A02MeZs/edit?usp=sharing"
            target="blank"
          >
            <img
              src={
                theme === "LIGHT"
                  ? "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447553/Portfolio%20App/ReadCV_gzd0zs.png"
                  : "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447183/Portfolio%20App/Union_alaubf.png"
              }
              alt="readCV"
            />
          </a>
          <a href="https://www.linkedin.com/in/omkumbhare" target="blank">
            <img
              src={
                theme === "LIGHT"
                  ? "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447567/Portfolio%20App/Group_dra5tf.png"
                  : "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447267/Portfolio%20App/Group_jvo36a.png"
              }
              alt="linkedIn"
            />
          </a>
          <a href="https://twitter.com/omkumbhare" target="blank">
            <img
              style={{
                backgroundColor: theme === "LIGHT" ? "transparent" : "#f6f6f6",
                borderRadius: theme === "LIGHT" ? "0" : "5px",
              }}
              src={
                theme === "LIGHT"
                  ? "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447567/Portfolio%20App/Frame_kpphfu.png"
                  : "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447567/Portfolio%20App/Frame_kpphfu.png"
              }
              alt="x"
            />
          </a>
        </div>
        <div>
          <a href="https://github.com/DEV-OMK" target="blank">
            <img
              src={
                theme === "LIGHT"
                  ? "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696446757/Portfolio%20App/github-mark_1_mzi8tn.png"
                  : "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696485284/Portfolio%20App/github-mark-white_1_xou4t4.png"
              }
              alt="github"
            />
          </a>
          <a href="https://discord.com/" target="blank">
            <img
              src={
                theme === "LIGHT"
                  ? "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447553/Portfolio%20App/%E5%9B%BE%E5%B1%82_2_tw01wp.png"
                  : "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696446543/Portfolio%20App/discord-mark-white_1_km7zww.svg"
              }
              alt="discord"
            />
          </a>
          <a href="https://www.behance.net/" target="blank">
            <img
              src={
                theme === "LIGHT"
                  ? "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447574/Portfolio%20App/Behance_aourbw.png"
                  : "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696485526/Portfolio%20App/Subtract_mxef7o.png"
              }
              alt="behance"
            />
          </a>
          <a href="https://dribbble.com/" target="blank">
            <img
              src={
                theme === "LIGHT"
                  ? "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696447567/Portfolio%20App/Dribbble_pfvdqh.png"
                  : "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696446380/Portfolio%20App/Vector_wnyaop.png"
              }
              alt="dribble"
            />
          </a>
        </div>
      </section>
    </div>
  );
};

export default Contact;
